<div class="ag-overlay-loading-center" role="presentation">{{ overlayText }}</div>
